import React, { Component } from 'react';
import {
	To_String,
	showPCNT,
	getContentParam,
} from '@/utils/common';
import { Img } from 'components/Material';
import config from '@/config';

const notice = config.notice;

export const handles = ['rRightDown', 'rLeftDown', 'rLeftUp', 'rRightUp', 'rUp', 'rRight', 'rDown', 'rLeft'];
export const dividings = ['dividingTop', 'dividingRight', 'dividingBottom', 'dividingLeft', 'dividingHCenter', 'dividingVCenter'];

export const defaultAreaCount = {
	0: 1, // video
	1: 4, // image
	2: 1, // text
	3: 5, // date
	4: 5, // time
	5: 5, // weather
	7: 1, // web
	9: 10, // bg
	18: 100, // stext
	19: 1, // floor
	20: 1, // touch
	26: 1, // dynamic table
	28: 1, // mask
	43: 1, // program
	78: 1, // pm2.5
}

export const defaultTextArea = {
	family: window.language['common.blackBody'],
	size: 40,
	color: "#FFFFFF",
	bgcolor: "#000000",
	opacity: "100%",
	rollmode: "1",
	rollspeed: "2",
	align: "0",
	valign: "0",
	playtime: "",
	rssid: "-1",
	content: '',
}

export const defaultDateArea = {
	bold: '0',
	color: '#FFFFFF',
	family: window.language['common.blackBody'],
	size: 40,
	style: '7',
	type: '1',
}

export const defaultTimeArea = {
	bold: '0',
	color: '#FFFFFF',
	family: window.language['common.blackBody'],
	size: 40,
	style: '1',
	type: '1',
}

export const defaultWeatherArea = {
	color: '#FFFFFF',
	family: window.language['common.blackBody'],
	size: 30,
	style: '8',
}

export const defaultBgArea = {
	bgcolor: "#000000",
}

export const defaultSTextArea = {
	bold: "",
	italic: "",
	underline: "",
	align: "left",
	size: 40,
	// family: "Arial",
	// familyId: "1",
	family: window.language['common.blackBody'],
	familyId: "27",
	color: "#FFFFFF",
	content: '',
}

export const defaultFloorArea = {
	family: window.language['common.blackBody'],
	size: 30,
	color: '#FFFFFF',
	bgcolor: "#000000",
}

export const defaultPMArea = {
	family: window.language['common.blackBody'],
	size: 40,
	color: "#FFFFFF",
	bgcolor: "#000000",
	opacity: "100%",
	rollmode: "1",
	rollspeed: "2",
	align: "0",
	valign: "0",
	playtime: "",
	rssid: "-1",
	content: '',
}

  //禁止重叠的div类型数组
export const divOverArray = [
	// {"div1":0,"div2":0},
	
	// {"div1":1,"div2":0},
	// {"div1":1,"div2":1},

	// {"div1":3,"div2":3},
	// {"div1":3,"div2":4},
	// {"div1":3,"div2":5},
	// {"div1":4,"div2":3},
	// {"div1":4,"div2":4},
	// {"div1":4,"div2":5},
	// {"div1":5,"div2":3},
	// {"div1":5,"div2":4},
	// {"div1":5,"div2":5},

	// {"div1":7,"div2":0},
	// {"div1":7,"div2":1},
	// {"div1":7,"div2":7},
	
	{"div1":18,"div2":0},
	{"div1":18,"div2":1},
  	{"div1":18,"div2":2},
	{"div1":18,"div2":3},
	{"div1":18,"div2":4},
   	{"div1":18,"div2":5},
  	{"div1":18,"div2":6},
	{"div1":18,"div2":7},
	{"div1":18,"div2":8},
	{"div1":18,"div2":18},
	{"div1":18,"div2":20},
	{"div1":18,"div2":26},
	{"div1":18,"div2":29},
	{"div1":18,"div2":61},
	{"div1":18,"div2":62},
	{"div1":18,"div2":63}
];

export const getAreaIds = function (areaArray, areaId) {
	let areaIds = [];
	getChildIds(areaArray, areaId, areaIds);
	return areaIds;
}

function getChildIds(areaArray, areaId, areaIds) {
	areaIds.push(areaId);
	for (let i = 0; i < areaArray.length; i++) {
		if (areaId === areaArray[i].parentId) {
			getChildIds(areaArray, areaArray[i].areaId, areaIds);
		}
	}
}

export const getDefaultFileName = function (filetype) {
	let name = '';
	if ('-14' === filetype) {
		name = window.language['playlist.material.webadddress'];
	} else if ('-21' === filetype) {
		name = window.language['playlist.material.poster'];
	} else if ('0' === filetype) {
		name = window.language['playlist.material.video'];
	} else if ('1' === filetype) {
		name = window.language['playlist.material.pic'];
	} else if ('2' === filetype) {
		name = window.language['playlist.material.music'];
	} else if ('7' === filetype) {
		name = window.language['playlist.material.web'];
	} else if ('14' === filetype) {
		name = window.language['playlist.material.live'];;
	} else if ('15' === filetype) {
		name = window.language['playlist.material.doc'];
	} else if ('16' === filetype) {
		name = window.language['playlist.material.xls'];
	} else if ('17' === filetype) {
		name = window.language['playlist.material.ppt'];
	} else if ('18' === filetype) {
		name = window.language['playlist.material.stext'];
	} else if ('21' === filetype) {
		name = window.language['playlist.poster.imp'];
	} else if ('22' === filetype) {
		name = window.language['playlist.poster.single'];
	} else if ('23' === filetype) {
		name = window.language['playlist.poster.multi'];
	} else if ('25' === filetype) {
		name = window.language['playlist.material.interactive'];
	} else if ('26' === filetype) {
		name = window.language['playlist.material.table'];
	} else if ('35' === filetype) {
		name = window.language['playlist.material.pdf'];
	} else if ('42' === filetype) {
		name = 'APK';
	}
	return name;
}

export const getDefaultTreeName = function (areaType, areaName) {
	let treename = '';
	if (-1 === areaType) {
		treename = areaName;
	} else if (0 === areaType) {
		treename = window.language['playlist.material.video'];
	} else if (1 === areaType) {
		treename = window.language['playlist.material.pic'];
	} else if (2 === areaType) {
		treename = window.language['playlist.material.text'];
	} else if (3 === areaType) {
		treename = window.language['playlist.material.date'];
	} else if (4 === areaType) {
		treename = window.language['playlist.material.time'];
	} else if (5 === areaType) {
		treename = window.language['playlist.material.weather'];
	} else if (7 === areaType) {
		treename = window.language['playlist.material.web'];
	} else if (9 === areaType) {
		treename = window.language['playlist.material.background'];
	} else if (18 === areaType) {
		treename = window.language['playlist.material.stext'];
	} else if (19 === areaType) {
		treename = window.language['playlist.material.floor'];
	} else if (20 === areaType) {
		treename = window.language['playlist.material.touch'];
	} else if (25 === areaType) {
		treename = 'p_touch_app_icon';
	} else if (26 === areaType) {
		treename = window.language['playlist.material.table'];
	} else if (28 === areaType) {
		treename = window.language['playlist.material.mask'];
	} else if (29 === areaType) {
		treename = 'p_touch_mask';
	} else if (43 === areaType) {
		treename = window.language['playlist.material.program'];
	} else if (78 === areaType) {
		treename = window.language['playlist.material.pm'];
	}
	return treename;
}
export const getDefaultImagePath = function (areaType) {
	let imgpath = null;
	if (0 === areaType) {
		imgpath = "images/program/sp.png";
	} else if (1 === areaType) {
		imgpath = "images/program/tp.png";
	} else if (2 === areaType) {
		imgpath = "images/program/music.png";
	} else if (7 === areaType) {
		imgpath = "images/program/web.png";
	} else if (9 === areaType) {
		imgpath = null;
	} else if (14 === areaType) {
		imgpath = "images/program/zhiboyuan.jpg";
	} else if (15 === areaType) {
		imgpath = "images/doc.png";
	} else if (16 === areaType) {
		imgpath = "images/material_excel.png";
	} else if (17 === areaType) {
		imgpath = "images/ppt.png";
	} else if (18 === areaType) {
		imgpath = "images/program/rss.png";
	} else if (19 === areaType) {
		imgpath = "images/program/floor.png";
	} else if (20 === areaType) {
		imgpath = "images/material/material-app-zip.png";
	} else if (21 === areaType) {
		imgpath = "images/posterimp.png";
	} else if (22 === areaType) {
		imgpath = "images/postersingle.png";
	} else if (23 === areaType) {
		imgpath = "images/postermulti.png";
	} else if (25 === areaType) {
		imgpath = "images/material/material-app-zip.png";
	} else if (26 === areaType) {
		imgpath = "images/material/material-dynamic-table.png";
	} else if (28 === areaType) {
		imgpath = "images/program/mask.jpg";
	} else if (35 === areaType) {
		imgpath = "images/material_pdf.png";
	} else if (78 === areaType) {
		imgpath = "images/program/pm.png";
	}
	if (imgpath) {
		// imgpath = require('assets/' + imgpath);
		imgpath = 'assets/' + imgpath;
	}
	return imgpath;
}

export const getDefaultPreviewPath = function (mediaArea, src) {
	if (mediaArea.filetype === '1') {
		src = `${mediaArea.sourcepath}`;
	} else {
		src = `${mediaArea.preview}`;
	}

	return src;
}
export const getDefaultPositionAndSize = function (areaType, templatewidth, templateheight) {
	let left = 0;
	let top = 0;
	let width = 300;
	let height = 250;
	if (areaType === 3) {
		let { size, style } = defaultDateArea;
		// let divSize = getDateParam(size, style);
		// width = divSize[0];
		// height = divSize[1];
		let content = showdate(style);
		let divSize = getContentParam(content, size);
		width = divSize.width;
		height = divSize.height;
		width += 7;
	} else if (areaType === 4) {
		let { size, style } = defaultTimeArea;
		let content = showtime(style);
		let divSize = getContentParam(content, size);
		width = divSize.width;
		height = divSize.height;
		width += 7;
	} else if (areaType === 5) {
		let { size, style } = defaultWeatherArea;
		let divSize = getWeatherParam(size, style);
		width = divSize[0];
		height = divSize[1];
	}
	let leftPcnt = showPCNT("left", left, templatewidth);
	let topPcnt = showPCNT("top", top, templateheight);
	let widthPcnt = showPCNT("width", width, templatewidth);
	let heightPcnt = showPCNT("height", height, templateheight);
	if (leftPcnt + widthPcnt > 100) {
		leftPcnt = 100 - widthPcnt;
		leftPcnt = To_String(leftPcnt, 2);
	}
	if (topPcnt + heightPcnt > 100) {
		topPcnt = 100 - heightPcnt;
		topPcnt = To_String(topPcnt, 2);
	}
	if (-1 === areaType || 9 === areaType || 43 === areaType) {
		left = 0;
		top = 0;
		width = templatewidth;
		height = templateheight;
		leftPcnt = 0;
		topPcnt = 0;
		widthPcnt = 100;
		heightPcnt = 100;
	}
	return {
		left,
		top,
		width,
		height,
		leftPcnt,
		topPcnt,
		widthPcnt,
		heightPcnt,
	}
}

function getAreaCount(areaArray, pageId, areaType) {
	let count = 0;
	for (let i = 0; i < areaArray.length; i++) {
		if ((pageId === areaArray[i].parentId) && (areaType === areaArray[i].areaType)) {
			count++;
		}
	}
	return count;
}

export const showAddAreaVisible = function (areaArray, pageId, areatype) {
	return getAreaCount(areaArray, pageId, areatype) >= defaultAreaCount[areatype];
}

export const getDefaultAreaCls = function (areaType) {
	let iconAreaCls = 'home';
	if (0 === areaType) {
		iconAreaCls = 'video';
	} else if (1 === areaType) {
		iconAreaCls = 'image';
	} else if (2 === areaType) {
		iconAreaCls = 'text';
	} else if (3 === areaType) {
		iconAreaCls = 'date';
	} else if (4 === areaType) {
		iconAreaCls = 'time';
	} else if (5 === areaType) {
		iconAreaCls = 'weather';
	} else if (7 === areaType) {
		iconAreaCls = 'web';
	} else if (9 === areaType) {
		iconAreaCls = 'bg';
	} else if (18 === areaType) {
		iconAreaCls = 'statictext';
	} else if (19 === areaType) {
		iconAreaCls = 'floor';
	} else if (20 === areaType) {
		iconAreaCls = 'Interaction';
	} else if (26 === areaType) {
		iconAreaCls = 'form';
	} else if (28 === areaType) {
		iconAreaCls = 'zhezhao';
	} else if (43 === areaType) {
		iconAreaCls = 'directory';
	} else if (78 === areaType) {
		iconAreaCls = 'granule';
	}
	return iconAreaCls;
}

export const getDefaultFiletypeCls = function (filetype) {
	let iconAreaCls = 'home';
	if ('0' === filetype) {
		iconAreaCls = 'video';
	} else if ('1' === filetype) {
		iconAreaCls = 'image';
	} else if ('2' === filetype) {
		iconAreaCls = 'music';
	} else if ('7' === filetype) {
		iconAreaCls = 'web';
	} else if ('14' === filetype) {
		iconAreaCls = 'live';
	} else if ('15' === filetype) {
		iconAreaCls = 'word';
	} else if ('16' === filetype) {
		iconAreaCls = 'excel';
	} else if ('17' === filetype) {
		iconAreaCls = 'ppt';
	} else if ('18' === filetype) {
		iconAreaCls = 'dtext';
	} else if ('21' === filetype) {
		iconAreaCls = 'imp';
	} else if ('22' === filetype) {
		iconAreaCls = 'singlesync';
	} else if ('23' === filetype) {
		iconAreaCls = 'backgroundmusic';
	} else if ('25' === filetype) {
		iconAreaCls = 'Interaction';
	} else if ('26' === filetype) {
		iconAreaCls = 'form';
	} else if ('35' === filetype) {
		iconAreaCls = 'pdf';
	} else if ('42' === filetype) {
		iconAreaCls = 'iconfont metarialapk';
	}
	return iconAreaCls;
}

export const addDataCountLimit = function (currentArea, filetype, dragDatas, dropDatas, maxmediaquantity) {
	let currentType = currentArea.areaType;
	let dragCount = dragDatas.length;
	let dropCount = dropDatas.length;
	let count = dragCount + dropCount;
	let playlist_des20 = window.language['playlist.workarea.des20'];
	let playlist_des42 = window.language['playlist.workarea.des42'];
	if (9 === currentType) {
		let _$records = dropDatas;
		if ('1' === filetype) {
			let imagecount = 0;// 背景区域是否存在图片
			for (let i = 0; i < _$records.length; i++) {
				let selected = _$records[i];
				if ('1' === selected['filetype']) {
					imagecount++;
				}
			}
			if (imagecount + dragCount > 1) {
				let str = playlist_des42.replace("{0}", imagecount + dragCount).replace("{1}", 1);
				notice.warning(str);
				return true;
			}
		} else if ('2' === filetype) {
			let musiccount = 0;// 背景区域音乐统计
			for (let i = 0; i < _$records.length; i++) {
				let selected = _$records[i];
				if ('2' === selected['filetype']) {
					musiccount++;
				}
			}
			if (musiccount + dragCount > maxmediaquantity) {
				let str = playlist_des20.replace("{0}", musiccount + dragCount).replace("{1}", maxmediaquantity);
				notice.warning(str);
				return true;
			}
		} else {
			let str = '不允许添加该类型素材';
			notice.warning(str);
			return true;
		}
	}
	if ((20 === currentType || 26 === currentType || 28 === currentType) && count > 1) {
		let str = playlist_des20.replace("{0}", count).replace("{1}", "1");
		notice.warning(str);
		return true;
	}
	if ((0 === currentType || 1 === currentType || 7 === currentType || 42 === currentType) && count > maxmediaquantity) {
		let str = playlist_des20.replace("{0}", count).replace("{1}", maxmediaquantity);
		notice.warning(str);
		return true;
	}
	return false;
}

export const getDefaultZindex = function (areaType, zIndex) {
	if (9 === areaType) {
		zIndex = 0;
	}
	return zIndex;
}

export const getDefaultRootName = function (playlisttype) {
	let name = new Date().getTime() + "";
	if (0 === playlisttype) {
		name = 'playlist' + name;
	}
	return name;
}

export const canAnchor = {
	0: '0',
	14: '14',
	20: '20',
	7: '7',
	1: '1',
	9: '9',
}

export const canNotMax = {
    3: '3',
    4: '4',
    5: '5',
    9: '9',
}

export const canNotShowMaterial = {
    // 2: '2',
    3: '3',
    4: '4',
    5: '5',
    9: '9',
    18: '18',
}

const canDrop = {
	0: {
		'0': 1000,
		'1': 1000,
		'2': 1000,
		'14': 1000,
		'15': 1000,
		'16': 1000,
		'17': 1000,
		'21': 1000,
		'22': 1000,
		'23': 1000,
		'35': 1000,
	},
	1: {
		'1': 1000
	},
	2: {
		'18': 1000
	},
	7: {
		'7': 1000,
	},
	9: {
		'1': 1000
	},
	20: {
		'25': 1000
	},
	26: {
		'26': 1000
	},
	28: {
		'1': 1000
	}
}

export const canDropMaterial = function (areaType, materialType, count) {
	let flag = false;
	try {
		flag = canDrop[areaType][materialType] > count;
	} catch (e) {
		flag = false;
	}
	return flag;
}
export const showdate = function (style) {	
	let { locale } = window.systemLanguage;	
	let date = new Date(); // 日期对象
	let data = "";
	let year = date.getFullYear();
	let month = date.getMonth() + 1 + "";
	let day = date.getDate() + "";
	month = month.length === 2 ? month : "0" + month;
	day = day.length === 2 ? day : "0" + day;
	let week = date.getDay();
	if ("1" === style) {
		data = year + "-"; // 读英文就行了
		data = data + month + "-";// 取月的时候取的是当前月-1如果想取当前月+1就可以了
		data = data + day;
	} else if ("2" === style) {
		if (locale === 'en') {
			let monName = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
			data = monName[date.getMonth()] + ' ' + date.getDate() + ',' + year;
		} else {
			data = year + "年"; // 读英文就行了
			data = data + month + "月";// 取月的时候取的是当前月-1如果想取当前月+1就可以了
			data = data + day + "日";
		}
	} else if ("3" === style) {
		let weekCode = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
		if (locale === 'en') {
			weekCode = ["Sun", "mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
			let monName = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
			data = monName[date.getMonth()] + ' ' + date.getDate() + ',' + year + ' ' + weekCode[week];
		} else {
			data = year + "年"; // 读英文就行了
			data = data + month + "月";// 取月的时候取的是当前月-1如果想取当前月+1就可以了
			data = data + day + "日";
			data = data + " " + weekCode[week];
		}
	} else if ("4" === style) {
		data = year + "/" + month + "/" + day;
	} else if ("5" === style) {
		data = day + "/" + month + "/" + year;
	} else if ("6" === style) {
		let weekCode = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
		if (locale === 'en') {
			weekCode = ["Sun", "mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
			let monName = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
			data = monName[date.getMonth()] + ' ' + date.getDate() + ',' + year + '<br/>' + weekCode[week];
		} else {
			data = year + "年"; // 读英文就行了
			data = data + month + "月";// 取月的时候取的是当前月-1如果想取当前月+1就可以了
			data = data + day + "日";
			data = data + "<br/>" + weekCode[week];
		}
	} else if ("7" === style) {
		data = showdate('2') + ' ' + showdate('9') + ' ' + showtime('1');
	} else if ("8" === style) {
		data = showdate('1') + ' ' + showdate('9') + ' ' + showtime('1');
	} else if ("9" === style) {
		let weekCode = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
		if (locale === 'en') {
			weekCode = ["Sun", "mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
		}
		data = weekCode[week];
	} else if ("10" === style) {
		let weekCode = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
		if (locale === 'en') {
			weekCode = ["Sun", "mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
			let monName = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
			data = monName[date.getMonth()] + ' ' + date.getDate() + ',' + weekCode[week];
		} else {
			data = data + month + "月";// 取月的时候取的是当前月-1如果想取当前月+1就可以了
			data = data + day + "日";
			data = data + " " + weekCode[week];
		}
	}
	return data;
}

export const showtime = function (style) {	
	let date = new Date(); // 日期对象
	let time = "";
	let hour = date.getHours() + "";
	let minute = date.getMinutes() + "";
	let second = date.getSeconds() + "";
	hour = hour.length === 2 ? hour : "0" + hour;
	minute = minute.length === 2 ? minute : "0" + minute;
	second = second.length === 2 ? second : "0" + second;
	if ('1' === style) {
		time = hour + ":";
		time = time + minute + ":";
		time = time + second;
	} else if ('2' === style) {
		time = hour + ":";
		time = time + minute;
	} else if ('3' === style) {
		time = parseInt(hour, 10) > 12 ? "PM " : "AM ";
		hour = parseInt(hour, 10) > 12 ? hour - 12 : hour;
		hour = hour.length === 2 ? hour : "0" + hour;
		time = time + hour + ":";
		time = time + minute;
	} else if ('4' === style) {
		time = parseInt(hour, 10) > 12 ? "PM " : "AM ";
		hour = parseInt(hour, 10) > 12 ? hour - 12 : hour;
		hour = hour.length === 2 ? hour : "0" + hour;
		time = time + hour + ":";
		time = time + minute + ":";
		time = time + second;
	}
	return time;
}

// 天气样式
export const showweather = function (style, size, family, color, ) {
	if ("1" === style) {
		return (
			<div style={{ width: '100%', height: size, lineHeight: size + 'px', top: '0%', left: '0%', position: 'absolute', color, }}>
				<font style={{ fontSize: size, fontFamily: family, }}>晴转多云 15℃/8℃</font>
			</div>
		)
	} else if ("2" === style) {
		return (
			<div style={{ width: '100%', height: size, lineHeight: size + 'px', top: '0%', left: '0%', position: 'absolute', color, }}>
				<font style={{ fontFamily: family, fontSize: size }}>晴转多云 15℃/8℃</font>
			</div>
		)
	} else if ("3" === style) {
		return (
			<div style={{ width: '100%', height: '100%', top: '0%', left: '0%', position: 'absolute', color, }}>
				<Img draggable={false} src="assets/images/partly_cloudy.gif" style={{ width: size * 2, height: size * 2, }} />
				<div>
					<font style={{ fontSize: size, lineHeight: size + 'px', fontFamily: family, }}>晴转多云 15℃/8℃</font>
				</div>
			</div>
		)
	} else if ("4" === style) {
		return (
			<table style={{ width: '100%', height: '100%', textAlign: 'center', color }}>
				<tbody>
					<tr>
						<td style={{ fontSize: size,  fontFamily: family, }}>今天</td>
						<td style={{ fontSize: size,  fontFamily: family, }}>明天</td>
						<td style={{ fontSize: size,  fontFamily: family, }}>后天</td>
					</tr>
					<tr>
						<td style={{ fontSize: size,  fontFamily: family, }}>15℃/8℃</td>
						<td style={{ fontSize: size,  fontFamily: family, }}>15℃/8℃</td>
						<td style={{ fontSize: size,  fontFamily: family, }}>15℃/8℃</td>
					</tr>
					<tr>
						<td>
							<Img draggable={false} src="assets/images/sunny.gif" style={{ width: size, height: size, }} />
						</td>
						<td>
							<Img draggable={false} src="assets/images/partly_cloudy.gif" style={{ width: size, height: size, }} />
						</td>
						<td>
							<Img draggable={false} src="assets/images/rain.gif" style={{ width: size, height: size, }} />
						</td>
					</tr>
				</tbody>
			</table>);
	} else if ("5" === style) {
		return (
			<div style={{ width: '100%', height: '100%', top: '0%', left: '0%', position: 'absolute', color, }}>
				<div style={{ textAlign: 'left', fontFamily: family, fontSize: size, lineHeight: size + 'px',  }}>&nbsp;南京
				</div>
				<Img draggable={false} src="assets/images/partly_cloudy.gif" style={{ width: size, height: size, }} />
				<div style={{ lineHeight: '1em', fontFamily: family, fontSize: size, lineHeight: size + 'px',  }}>晴转多云 15℃/8℃</div>
			</div>
		)
	} else if ("6" === style) {
		return (
			<div style={{ width: '100%', height: '100%', top: '0%', left: '0%', position: 'absolute', color, }}>
				<table style={{ textAlign: 'left', width: '100%', height: '100%' }}>
					<tbody>
						<tr>
							<td style={{ fontSize: size, lineHeight: size + 'px',  fontFamily: family, }}>今天</td>
							<td style={{ fontSize: size, lineHeight: size + 'px',  fontFamily: family, }}>明天</td>
							<td style={{ fontSize: size, lineHeight: size + 'px',  fontFamily: family, }}>后天</td>
						</tr>
						<tr>
							<td style={{ fontSize: size, lineHeight: size + 'px',  fontFamily: family, }}>15℃/8℃</td>
							<td style={{ fontSize: size, lineHeight: size + 'px',  fontFamily: family, }}>15℃/8℃</td>
							<td style={{ fontSize: size, lineHeight: size + 'px',  fontFamily: family, }}>15℃/8℃</td>
						</tr>
						<tr>
							<td>
								<Img draggable={false} src="assets/images/sunny.gif" style={{ width: size, height: size }} />
							</td>
							<td>
								<Img draggable={false} src="assets/images/partly_cloudy.gif" style={{ width: size, height: size }} />
							</td>
							<td>
								<Img draggable={false} src="assets/images/rain.gif" style={{ width: size, height: size }} />
							</td>
						</tr>
						<tr>
							<td style={{ fontSize: size, lineHeight: size + 'px',  fontFamily: family, }}>空气质量：151 中度污染</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td style={{ fontSize: size, lineHeight: size + 'px',  fontFamily: family, }}>湿度： 96%</td>
							<td></td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	} else if ("8" === style) {
		return (
			<table style={{ width: '100%', height: '100%', textAlign: 'center', color }}>
				<tbody>
					<tr>
						<td valign="top" style={{ fontSize: Math.floor(size * 117 / 32),  fontFamily: family, }}>15<span style={{fontFamily: 'arial'}}>°</span></td>
						<td>
							<table style={{ width: '100%', height: '100%', textAlign: 'left' }}>
								<tbody>
									<tr>
										<td style={{ fontSize: Math.floor(size * 50 / 32),  fontFamily: family, }}>南京</td>
									</tr>
									<tr>
										<td style={{ fontSize: Math.floor(size),  fontFamily: family, }}>晴转多云</td>
									</tr>
								</tbody>
							</table>
						</td>
						<td>
							<Img draggable={false} src="assets/images/sunnynew.png" style={{ width: Math.floor(size * 128 / 32), height: Math.floor(size * 128 / 32), }} />
						</td>
					</tr>
				</tbody>
			</table>
		)
	} else if ("9" === style) {
		return (
			<table style={{ width: '100%', height: '100%', textAlign: 'center', color }}>
				<tbody>
					<tr>
						<td>
							<Img draggable={false} src="assets/images/sunnynew.png" style={{ width: Math.floor(size * 168 / 24), height: Math.floor(size * 168 / 24), }} />
						</td>
						<td>
							<div style={{width: 2, height: '80%', borderLeft: '2px solid #ffffff', margin: '0 ' +Math.floor(size * 30 / 32) + 'px'}}></div>
						</td>
						<td style={{ width: '100%', height: '100%', textAlign: 'left' }}>
							<table style={{ width: '100%', height: '100%',}}>
								<tbody>
									<tr>
										<td style={{ fontSize: Math.floor(size),  fontFamily: family, }}>晴转多云</td>
									</tr>
									<tr>
										<td style={{ fontSize: Math.floor(size * 50 / 32),  fontFamily: family, }}>15<span style={{fontFamily: 'arial'}}>°</span>/8<span style={{fontFamily: 'arial'}}>°</span></td>
									</tr>
									<tr>
										<td style={{ fontSize: Math.floor(size),  fontFamily: family, }}>南京</td>
									</tr>
									<tr>
										<td style={{ fontSize: Math.floor(size),  fontFamily: family, }}>{showdate('10')}</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</tbody>
			</table>
		)
	}
}

export const getDateParam = function (size, style) {
	let fontWidth = 330;
	let fontHeight = 64;
	if ("1" === style || "4" === style || "5" === style) {
		if (30 === size) {
			fontWidth = 190;
			fontHeight = 35;
		}
		else if (60 === size) {
			fontWidth = 350;
			fontHeight = 64;
		}
		else if (40 === size) {
			fontWidth = 250;
			fontHeight = 45;
		}
		else if (20 === size) {
			fontWidth = 140;
			fontHeight = 32;
		}
		else if (25 === size) {
			fontWidth = 180;
			fontHeight = 32;
		}
	}
	else if ("2" === style) {
		if (30 === size) {
			fontWidth = 250;
			fontHeight = 45;
		}
		else if (60 === size) {
			fontWidth = 470;
			fontHeight = 64;
		}
		else if (40 === size) {
			fontWidth = 312;
			fontHeight = 45;
		}
		else if (20 === size) {
			fontWidth = 200;
			fontHeight = 32;
		}
		else if (25 === size) {
			fontWidth = 210;
			fontHeight = 32;
		}
	}
	else if ("3" === style) {
		if (30 === size) {
			fontWidth = 350;
			fontHeight = 35;
		}
		else if (60 === size) {
			fontWidth = 670;
			fontHeight = 64;
		}
		else if (40 === size) {
			fontWidth = 470;
			fontHeight = 45;
		}
		else if (20 === size) {
			fontWidth = 280;
			fontHeight = 32;
		}
		else if (25 === size) {
			fontWidth = 300;
			fontHeight = 32;
		}
	}
	let rec = new Array(1);
	// rec[0] = parseInt(fontWidth, 10); 
	// rec[1] = parseInt(fontHeight, 10); 
	rec[0] = fontWidth;
	rec[1] = fontHeight;
	return rec;
}

export const getTimeParam = function (size, style) {
	let fontWidth = 175;
	let fontHeight = 64;
	if (20 === size || 25 === size) {
		fontHeight = 32;
		fontWidth = 128;
	}
	if ("1" === style) {
		if (30 === size) {
			fontWidth = 175;
			fontHeight = 35;
		}
		else if (60 === size) {
			fontWidth = 280;
			fontHeight = 64;
		}
		else if (40 === size) {
			fontHeight = 45;
			fontWidth = 185;
		}
	}
	else if ("2" === style) {
		if (30 === size) {
			fontWidth = 110;
			fontHeight = 35;
		}
		else if (60 === size) {
			fontWidth = 170;
			fontHeight = 64;
		}
		else if (40 === size) {
			fontWidth = 128;
			fontHeight = 45;
		}
	}
	else if ("3" === style) {
		if (30 === size) {
			fontWidth = 155;
			fontHeight = 35;
		}
		else if (60 === size) {
			fontWidth = 278;
			fontHeight = 64;
		}
		else if (40 === size) {
			fontWidth = 185;
			fontHeight = 45;
		}
	}
	else if ("4" === style) {
		if (30 === size) {
			fontWidth = 256;
			fontHeight = 35;
		}
		else if (60 === size) {
			fontWidth = 450;
			fontHeight = 64;
		}
		else if (40 === size) {
			fontWidth = 340;
			fontHeight = 45;
		}
		else if (25 === size || 20 === size) {
			fontWidth = 180;
			fontHeight = 45;
		}
	}
	let rec = new Array(1);
	// rec[0] = parseInt(fontWidth, 10); 
	// rec[1] = parseInt(fontHeight, 10);
	rec[0] = fontWidth;
	rec[1] = fontHeight;
	return rec;
}

export const getWeatherParam = function (size, style) {
	// let fontWidth = 220;
	// let fontHeight = 24;
	// if (30 === size) {
	// 	fontWidth = 320;
	// 	fontHeight = 36;
	// }
	// else if (40 === size) {
	// 	fontWidth = 420;
	// 	fontHeight = 40;
	// }
	// else if (20 === size) {
	// 	fontHeight = 24;
	// 	fontWidth = 320;
	// }
	// else if (25 === size) {
	// 	fontHeight = 32;
	// 	fontWidth = 320;
	// }
	// if ("5" === style) {
	// 	if (30 === size) {
	// 		fontHeight = 164;
	// 	}
	// 	else if (40 === size) {
	// 		fontHeight = 218;
	// 	}
	// 	else if (20 === size) {
	// 		fontHeight = 130;
	// 		fontWidth = 320;
	// 	}
	// 	else if (25 === size) {
	// 		fontHeight = 140;
	// 		fontWidth = 320;
	// 	}
	// }
	// else if ("3" === style) {
	// 	if (30 === size) {
	// 		fontHeight = 120;
	// 		fontWidth = 320;
	// 	}
	// 	else if (40 === size) {
	// 		fontHeight = 140;
	// 		fontWidth = 420;
	// 	}
	// 	else if (20 === size) {
	// 		fontHeight = 84;
	// 		fontWidth = 280;
	// 	}
	// 	else if (25 === size) {
	// 		fontHeight = 92;
	// 		fontWidth = 300;
	// 	}
	// }
	// else if ("4" === style) {
	// 	if (30 === size) {
	// 		fontHeight = 170;
	// 		fontWidth = 500;
	// 	}
	// 	else if (40 === size) {
	// 		fontHeight = 200;
	// 		fontWidth = 620;
	// 	}
	// 	else if (20 === size) {
	// 		fontHeight = 115;
	// 		fontWidth = 360;
	// 	}
	// 	else if (25 === size) {
	// 		fontHeight = 140;
	// 		fontWidth = 405;
	// 	}
	// }
	// else if ("6" === style) {
	// 	if (30 === size) {
	// 		fontHeight = 170;
	// 		fontWidth = 1080;
	// 	}
	// 	else if (40 === size) {
	// 		fontHeight = 220;
	// 		fontWidth = 1380;
	// 	}
	// 	else if (20 === size) {
	// 		fontHeight = 115;
	// 		fontWidth = 720;
	// 	}
	// 	else if (25 === size) {
	// 		fontHeight = 140;
	// 		fontWidth = 880;
	// 	}
	// }
	// let rec = new Array(1);
	// // rec[0] = parseInt(fontWidth, 10); 
	// // rec[1] = parseInt(fontHeight, 10); 
	// rec[0] = fontWidth;
	// rec[1] = fontHeight;
	// return rec;
	
	let content = '晴转多云 25℃/28℃';
	let divSize = getContentParam(content, size);
	let rec = [];
	rec[0] = divSize.width;
	rec[1] = divSize.height;
	if (style === '1') {
		rec[0] = divSize.width;
		rec[1] = divSize.height + 5;
	}else if (style === '3') {
		rec[0] = divSize.width;
		rec[1] = divSize.height * 3;
	}else if (style === '4' || style === '6') {
		content = '25℃/28℃';
		divSize = getContentParam(content, size);
		rec[0] = divSize.width * 3;
		rec[1] = divSize.height * 6;
	}else if (style === '5') {
		rec[0] = divSize.width;
		rec[1] = divSize.height * 3;
	}else if (style === '8') {
		content = '晴转多云';
		divSize = getContentParam(content, size);
		rec[0] = Math.ceil(divSize.width * 140 / 32);
		rec[1] = Math.ceil(divSize.height * 170 / 32);
	}else if (style === '9') {
		content = '晴转多云';
		divSize = getContentParam(content, size);
		rec[0] = Math.ceil(divSize.width * 140 / 32);
		rec[1] = Math.ceil(divSize.height * 230 / 32);
	}
	return rec;
}


// WEBPACK FOOTER //
// ./src/components/Playlist/PlaylistUtil.js